module.exports = __webpack_public_path__ + "r-v3/img/mobile_premium_feature_005.7f6d7ad3.jpg";